var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCancel = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 15035",
  transform: "translate(-208 -332)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#e83f4b",
  "data-name": "Ellipse 1551",
  transform: "translate(208 332)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 14672"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M219 342.999h19v19h-19z",
  "data-name": "Rectangle 5634"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 14674"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  "data-name": "Group 14673"
}, /*#__PURE__*/React.createElement("path", {
  d: "m222.526 346.526 11.391 11.391",
  "data-name": "Line 1232"
}), /*#__PURE__*/React.createElement("path", {
  d: "m233.917 346.526-11.391 11.391",
  "data-name": "Line 1233"
})))))));
export { SvgCancel as ReactComponent };
export default __webpack_public_path__ + "static/media/cancel.c386a194a423d0cf8788ccc715b168e3.svg";